function getJsonSchemaAdditionalVcsRoot(name: string) {
  return {
    [name]: {
      type: 'object',
      properties: {
        enabled: {
          type: 'boolean',
        },
      },
      additionalProperties: false,
    },
  }
}

export default getJsonSchemaAdditionalVcsRoot
